import { UserroleModalUpdateComponent } from './userrole-modal-update.component';
import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { UserRole } from './userrole';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-userrole',
  templateUrl: './userrole.component.html',
  providers: [
    //ModalService,
    //NgbModal
  ]
})
export class UserroleComponent
  extends BaseModalContainer<UserRole>
  implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<UserRole>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    private ngbModalService: NgbModal,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
    //this.ngbModalService.open(UserroleModalUpdateComponent);
  }

}
